module.exports = __webpack_public_path__ + "img/42.6d83a081.jpg";